import { createSlice } from '@reduxjs/toolkit';
import { START_OF_WEEK } from '../../../constents';
import { endOfWeek, formatISO, startOfWeek } from 'date-fns';

export const summarySlice = createSlice({
  name: 'summary',
  initialState: {
    sumPeriodFilter: {
      name: 'week',
      startDate: formatISO(startOfWeek(new Date(), START_OF_WEEK)),
      endDate: formatISO(endOfWeek(new Date(), START_OF_WEEK)),
    },
  },
  reducers: {
    setSumPeriod: (state, action) => {
      state.sumPeriodFilter = action.payload;
    },
  },
});

export const { setSumPeriod } = summarySlice.actions;
export default summarySlice.reducer;
